import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=324ecab1&scoped=true&lang=html&"
import script from "./purchase.vue?vue&type=script&lang=js&"
export * from "./purchase.vue?vue&type=script&lang=js&"
import style0 from "./purchase.vue?vue&type=style&index=0&id=324ecab1&lang=scss&scoped=true&"
import style1 from "./purchase.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./purchase.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./purchase.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ecab1",
  null
  
)

export default component.exports